import React, {useState, useEffect, lazy, Suspense, useRef} from "react";
import Timer from "./timer";

const Map = lazy(() => import("./map"));

export default function Ready(props) {
    const tampa = {lat: 27.9469,lng: -82.4672};

    const [showMap, setShowMap] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);
    const publicBase = process.env.PUBLIC_URL || "";
    const defaultSrc = `${publicBase}/images/${props?.bayday?.Picture || ""}`;
    const placeholder = `data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='800' height='500'><rect width='100%' height='100%' fill='%23e6e6e6'/><text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' fill='%23999' font-size='20'>Image not available</text></svg>`;
    const [imageSrc, setImageSrc] = useState(defaultSrc);

    // Build a map of bundled images in src/images (works at build time).
    let bundledImages = {};
    try {
      const req = require.context('../images', false, /\.(png|jpe?g|webp|svg)$/);
      req.keys().forEach((key) => {
        const filename = key.replace('./', '');
        bundledImages[filename] = req(key);
      });
    } catch (e) {
      bundledImages = {};
    }

    useEffect(() => {
        setImageSrc(`${publicBase}/images/${props?.bayday?.Picture || ""}`);
        setImageLoaded(false);
        setImageError(false);
    }, [props?.bayday?.Picture, publicBase]);

    const startTimeRef = useRef(null);
    const [timerRunning, setTimerRunning] = useState(false);

    const handleButtonClick = () => {
        setShowMap(true);
        // start timer
        startTimeRef.current = Date.now();
        setTimerRunning(true);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleButtonClick();
        }
    };

    const altText = props?.bayday?.Caption || props?.bayday?.Title || "Location photo";

    const onImgLoad = () => setImageLoaded(true);
    const onImgError = () => {
      setImageError(true);
      // Try bundled images (src/images)
      const file = props?.bayday?.Picture;
      if (file && bundledImages[file]) {
        setImageSrc(bundledImages[file]);
        setImageError(false);
        // let the new src attempt to load; do not set imageLoaded yet
        return;
      }

      // final fallback: inline placeholder
      setImageSrc(placeholder);
      setImageLoaded(true);
    };

    return (
    <div className="map-container">
        {showMap ? (
          <>
            <div className="reveal-view">
              <Suspense fallback={<div className="spinner">Loading map...</div>}>
                <Map
                  bayday={props.bayday}
                  marker={tampa}
                  guessing={true}
                  getElapsed={() => startTimeRef.current ? Date.now() - startTimeRef.current : 0}
                  onStopTimer={() => setTimerRunning(false)}
                  imageSrc={imageSrc}
                  imageCaption={props?.bayday?.Caption}
                  timerRunning={timerRunning}
                  startTimeRef={startTimeRef}
                />
              </Suspense>
            </div>
          </>
        ) : (
          <>
            <h1 className="title2">Where do you think this picture was taken?</h1>

            <div className="photo-card">
              {!imageLoaded && (
                <div className="spinner">Loading image...</div>
              )}

              <img
                src={imageSrc}
                className="image"
                alt={altText}
                onLoad={onImgLoad}
                onError={onImgError}
                style={{display: imageLoaded ? 'block' : 'none'}}
              />

              {props?.bayday?.Caption && (
                <div className="caption">{props.bayday.Caption}</div>
              )}
            </div>

            <button
              className="ready-btn"
              onClick={handleButtonClick}
              onKeyDown={handleKeyDown}
              aria-label="Reveal map and place your pin"
            >
              Reveal Map
            </button>
          </>
        )}
    </div>
    )
}